var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erp-form-header"},[_c('el-page-header',{attrs:{"content":(_vm.title + " " + (_vm.headerProp || _vm.$t(_vm.header)))},on:{"back":_vm.back}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }